"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Toolbox = _interopRequireDefault(require("../Toolbox"));
var _button = require("../../button");
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Operator = _interopRequireDefault(require("../Operator"));
var _Bracket = _interopRequireDefault(require("../Bracket"));
var _Function = _interopRequireDefault(require("../Function"));
var _input = require("../../input");
var _icon = _interopRequireDefault(require("../../icon"));
var _helpers = require("../helpers");
var _constants = require("../constants");
var _helpers2 = require("./helpers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FormulaMember = /*#__PURE__*/function (_Component) {
  _inherits(FormulaMember, _Component);
  var _super = _createSuper(FormulaMember);
  function FormulaMember(props) {
    var _this;
    _classCallCheck(this, FormulaMember);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "clearFocus", function () {
      _this.setState({
        isFocused: false
      });
    });
    _this.state = {
      isFocused: false
    };
    return _this;
  }
  _createClass(FormulaMember, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        keysPath = _this$props.keysPath,
        labels = _this$props.labels,
        actions = _this$props.actions,
        errors = _this$props.errors,
        disabled = _this$props.disabled,
        member = _this$props.member,
        formulaOperators = _this$props.formulaOperators,
        noDelete = _this$props.noDelete,
        ruleIndex = _this$props.ruleIndex,
        noFunctions = _this$props.noFunctions;
      var hasError = R.prop([keysPath.join('.')], (0, _utils.flattenObject)(errors));
      var isFocused = this.state.isFocused;
      var type = member.type,
        value = member.value,
        description = member.description,
        displayName = member.displayName;
      var isBaseInFunction = (0, _helpers.isBaseArgumentInFunction)(keysPath);
      var showDelete = !disabled && (0, _helpers.shouldShowDelete)({
        noDelete: noDelete,
        isFocused: isFocused,
        keysPath: keysPath,
        isBaseInFunction: isBaseInFunction,
        type: type
      });
      var showToolboxAndAdd = !disabled && isFocused && type !== _constants.FORMULA_MEMBER_TYPES.textOnly && !R.equals(member.dataType, _constants.DATA_TYPES.NUMERIC);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "formula-element-wrapper formula-".concat(type, "-wrapper"),
        onClick: function onClick(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        },
        onFocus: function onFocus(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        },
        onBlur: this.clearFocus,
        role: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress(ev) {
          ev.stopPropagation();
          _this2.setState({
            isFocused: true
          });
        }
      }, showDelete && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button delete-member",
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.deleteFormulaMember(keysPath);
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-delete",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "formula-element"
      }, function () {
        switch (type) {
          case _constants.FORMULA_MEMBER_TYPES.textOnly:
            return /*#__PURE__*/_react["default"].createElement(_input.RichTextarea, {
              ariaDescribedBy: "blockSubtitle",
              value: member.value,
              disabled: disabled,
              error: hasError ? labels.RULES_BUILDER_DETAILS_MISSING : '',
              onChange: function onChange(event) {
                return actions.formulaChange({
                  value: (0, _utils.getEventValue)(event),
                  type: _constants.FORMULA_MEMBER_TYPES.textOnly,
                  description: description,
                  displayName: displayName
                }, keysPath);
              },
              placeholder: labels.RULES_BUILDER_TEXT_ONLY_REWARD_PLACEHOLDER
            });
          case _constants.FORMULA_MEMBER_TYPES.variable:
          case _constants.FORMULA_MEMBER_TYPES.numeric:
          case _constants.FORMULA_MEMBER_TYPES.percentage:
          case _constants.FORMULA_MEMBER_TYPES.empty:
            return /*#__PURE__*/_react["default"].createElement(_Searchable["default"], _extends({
              isFocused: isFocused,
              labels: labels,
              disabled: disabled
            }, member, {
              uniqueKey: member.key,
              error: hasError,
              ruleIndex: ruleIndex,
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              },
              searchableAction: actions.getFormulaOperandValues,
              clearFocus: _this2.clearFocus,
              keysPath: keysPath
            }, (0, _helpers2.setRoundFieldProperties)({
              member: member,
              labels: labels
            })));
          case _constants.FORMULA_MEMBER_TYPES.operator:
            return /*#__PURE__*/_react["default"].createElement(_Operator["default"], {
              disabled: disabled,
              error: hasError,
              value: value,
              labels: labels,
              placeholder: "",
              formulaOperators: formulaOperators,
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(_objectSpread(_objectSpread({}, data), {}, {
                  type: _constants.FORMULA_MEMBER_TYPES.operator
                }), keysPath);
              },
              clearFocus: _this2.clearFocus
            });
          case _constants.FORMULA_MEMBER_TYPES.functionMember:
            return /*#__PURE__*/_react["default"].createElement(_Function["default"], {
              args: member.arguments,
              renderMember: function renderMember(_ref) {
                var otherProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
                return /*#__PURE__*/_react["default"].createElement(FormulaMember, _extends({}, _this2.props, otherProps, {
                  noDelete: false
                }));
              },
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              },
              keysPath: keysPath,
              value: (0, _helpers2.renderFunctionLabel)({
                value: value,
                labels: labels
              }),
              disabled: disabled,
              labels: labels
            });
          case _constants.FORMULA_MEMBER_TYPES.parenthesis:
            return /*#__PURE__*/_react["default"].createElement(_Bracket["default"], _extends({}, member, {
              formulaChange: function formulaChange(data) {
                return actions.formulaChange(data, keysPath);
              }
            }));
          default:
            return '';
        }
      }()), showToolboxAndAdd && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button add-member",
        onMouseDown: function onMouseDown(ev) {
          ev.stopPropagation();
          actions.addFormulaMember(type, keysPath, value);
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-plus",
        size: 16
      })), /*#__PURE__*/_react["default"].createElement(_Toolbox["default"], _extends({}, this.props, {
        noFunctions: [_constants.FORMULA_MEMBER_TYPES.variable, _constants.FORMULA_MEMBER_TYPES.numeric, _constants.FORMULA_MEMBER_TYPES.percentage, _constants.FORMULA_MEMBER_TYPES.textOnly, _constants.FORMULA_MEMBER_TYPES.parenthesis].includes(type) && !isBaseInFunction || noFunctions,
        noBetween: true,
        disabled: disabled,
        noGroups: type === _constants.FORMULA_MEMBER_TYPES.operator || type === _constants.FORMULA_MEMBER_TYPES.textOnly || isBaseInFunction,
        functionsEnabled: !(0, _helpers.hasReachedMaxNestingDept)(keysPath),
        paranthesesEnabled: true,
        focusedPath: [],
        betweenEnabled: true,
        keysPath: keysPath,
        clearFocus: this.clearFocus
      }))));
    }
  }]);
  return FormulaMember;
}(_react.Component);
FormulaMember.defaultProps = {
  disabled: false,
  errors: '',
  noDelete: false,
  noFunctions: false
};
FormulaMember.propTypes = {
  noFunctions: _propTypes["default"].bool,
  member: _propTypes["default"].shape({
    type: _propTypes["default"].string,
    dataType: _propTypes["default"].string,
    value: _propTypes["default"].string,
    description: _propTypes["default"].string,
    displayName: _propTypes["default"].string,
    key: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    arguments: _propTypes["default"].arrayOf(_propTypes["default"].arrayOf(_propTypes["default"].shape({
      value: _propTypes["default"].string,
      type: _propTypes["default"].string,
      displayName: _propTypes["default"].string
    })))
  }).isRequired,
  noDelete: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  keysPath: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])), _propTypes["default"].number]).isRequired
};
FormulaMember.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "clearFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "FormulaMember",
  "props": {
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "shape",
          "value": {}
        }]
      },
      "required": false
    },
    "noDelete": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "noFunctions": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "member": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "type": {
            "name": "string",
            "required": false
          },
          "dataType": {
            "name": "string",
            "required": false
          },
          "value": {
            "name": "string",
            "required": false
          },
          "description": {
            "name": "string",
            "required": false
          },
          "displayName": {
            "name": "string",
            "required": false
          },
          "key": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }],
            "required": false
          },
          "arguments": {
            "name": "arrayOf",
            "value": {
              "name": "arrayOf",
              "value": {
                "name": "shape",
                "value": {
                  "value": {
                    "name": "string",
                    "required": false
                  },
                  "type": {
                    "name": "string",
                    "required": false
                  },
                  "displayName": {
                    "name": "string",
                    "required": false
                  }
                }
              }
            },
            "required": false
          }
        }
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    },
    "ruleIndex": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "formulaOperators": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "displayName": {
              "name": "string",
              "required": false
            },
            "name": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "actions": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "func"
        }
      },
      "required": true
    },
    "keysPath": {
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "arrayOf",
          "value": {
            "name": "union",
            "value": [{
              "name": "string"
            }, {
              "name": "number"
            }]
          }
        }, {
          "name": "number"
        }]
      },
      "required": true
    }
  }
};
var _default = FormulaMember;
exports["default"] = _default;